export const homeFaqs = [
  {
    question: 'Do you repair both gearboxes and hydraulics?',
    answer:
      'Yes. We focus on industrial gearbox repair, hydraulic cylinder repair, and related mechanical repair work.',
  },
  {
    question: 'Do you serve customers outside Ontario?',
    answer:
      'Yes. The service area is Canada-wide. Share your location and equipment details when requesting a quote.',
  },
  {
    question: 'What details should I send for a quote?',
    answer:
      'Send the equipment type, brand or model if available, photos, symptoms, and any urgency around downtime.',
  },
  {
    question: 'When should a gearbox or hydraulic cylinder be inspected?',
    answer:
      'Common signs include leaks, overheating, unusual noise, vibration, loss of pressure, reduced output, or visible wear.',
  },
  {
    question: 'Can repair be better than replacement?',
    answer:
      'In many cases, repairing or rebuilding industrial components can reduce downtime and avoid the cost of sourcing a full replacement.',
  },
  {
    question: 'What gearbox problems can you look at?',
    answer:
      'We can review issues such as bearing wear, gear damage, seal failure, oil contamination, overheating, vibration, and loss of output.',
  },
  {
    question: 'What hydraulic issues should I ask about?',
    answer:
      'Send details for cylinder leaks, scoring, damaged rods, seal failure, pressure loss, drift, or worn mounting points.',
  },
  {
    question: 'Can you work from photos first?',
    answer:
      'Yes. Photos, nameplates, dimensions, and symptom notes are useful for the first review before the repair path is confirmed.',
  },
];
